import { ILaya } from "../../../../../ILaya";
import { ShaderDataType } from "../../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../../layagl/LayaGL";
import { Vector3 } from "../../../../maths/Vector3";
import { Vector4 } from "../../../../maths/Vector4";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Volume } from "../Volume";
import { VolumeManager } from "../VolumeManager";
export class VolumetricGI extends Volume {
    static init() {
        VolumetricGI.SHADERDEFINE_VOLUMETRICGI = Shader3D.getDefineByName("VOLUMETRICGI");
        VolumetricGI.VOLUMETRICGI_PROBECOUNTS = Shader3D.propertyNameToID("u_VolGIProbeCounts");
        VolumetricGI.VOLUMETRICGI_PROBESTEPS = Shader3D.propertyNameToID("u_VolGIProbeStep");
        VolumetricGI.VOLUMETRICGI_PROBESTARTPOS = Shader3D.propertyNameToID("u_VolGIProbeStartPosition");
        VolumetricGI.VOLUMETRICGI_PROBEPARAMS = Shader3D.propertyNameToID("u_VolGIProbeParams");
        VolumetricGI.VOLUMETRICGI_IRRADIANCE = Shader3D.propertyNameToID("u_ProbeIrradiance");
        VolumetricGI.VOLUMETRICGI_DISTANCE = Shader3D.propertyNameToID("u_ProbeDistance");
        let uniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap(VolumetricGI.BlockName);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_PROBECOUNTS, "u_VolGIProbeCounts", ShaderDataType.Vector3);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_PROBESTEPS, "u_VolGIProbeStep", ShaderDataType.Vector3);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_PROBESTARTPOS, "u_VolGIProbeStartPosition", ShaderDataType.Vector3);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_PROBEPARAMS, "u_VolGIProbeParams", ShaderDataType.Vector4);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_IRRADIANCE, "u_ProbeIrradiance", ShaderDataType.Texture2D);
        uniformMap.addShaderUniform(VolumetricGI.VOLUMETRICGI_DISTANCE, "u_ProbeDistance", ShaderDataType.Texture2D);
    }
    static getID() {
        return VolumetricGI.volumetricCount++;
    }
    get shaderData() {
        return this._dataModule.shaderData;
    }
    constructor() {
        super();
        this._type = VolumeManager.VolumetricGIType;
        this._probeCounts = new Vector3();
        this._probeStep = new Vector3();
        this._params = new Vector4(8, 16, 0, 0);
        this._dataModule = Laya3DRender.Render3DModuleDataFactory.createVolumetricGI();
        this._dataModule.setParams(this._params);
        this._volumetricProbeID = VolumetricGI.getID();
        this._dataModule.intensity = 1;
    }
    _onEnable() {
        super._onEnable();
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get irradiance() {
        return this._irradiance;
    }
    set irradiance(value) {
        if (this._irradiance == value)
            return;
        this._irradiance && (this._irradiance._removeReference());
        if (value) {
            value._addReference();
            this._dataModule.irradiance = value._texture;
        }
        else {
            this._dataModule.irradiance = null;
        }
        this._irradiance = value;
        this._irradiance = value;
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get distance() {
        return this._distance;
    }
    set distance(value) {
        if (this._distance == value)
            return;
        this._distance && (this._distance._removeReference());
        if (value) {
            value._addReference();
            this._dataModule.distance = value._texture;
        }
        else {
            this._dataModule.distance = null;
        }
        this._distance = value;
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get normalBias() {
        return this._params.z;
    }
    set normalBias(value) {
        this._params.z = value;
        this._dataModule.setParams(this._params);
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get viewBias() {
        return this._params.w;
    }
    set viewBias(value) {
        this._params.w = value;
        this._dataModule.setParams(this._params);
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get irradianceTexel() {
        return this._params.x;
    }
    get distanceTexel() {
        return this._params.y;
    }
    get intensity() {
        return this._dataModule.intensity;
    }
    set intensity(value) {
        if (value == this._dataModule.intensity)
            return;
        value = Math.max(value, 0.0);
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get probeCounts() {
        return this._probeCounts;
    }
    set probeCounts(value) {
        if (value.equal(this._probeCounts))
            return;
        value.cloneTo(this._probeCounts);
        this._dataModule.setProbeCounts(value);
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    get probeStep() {
        return this._probeStep;
    }
    set probeStep(value) {
        if (value.equal(this._probeStep))
            return;
        value.cloneTo(this._probeStep);
        this._dataModule.setProbeStep(value);
        this._dataModule.updateMark = ILaya.Scene3D._updateMark;
    }
    _reCaculateBoundBox() {
        super._reCaculateBoundBox();
        this.bounds.cloneTo(this._dataModule.bound);
    }
    _onDestroy() {
        this.irradiance = null;
        this.distance = null;
        this._dataModule.destroy();
        this._dataModule = null;
    }
    _cloneTo(dest) {
        dest.irradiance = this.irradiance;
        dest.distance = this.distance;
        this._probeCounts.cloneTo(dest._probeCounts);
        this.probeStep.cloneTo(dest.probeStep);
        dest.normalBias = this.normalBias;
        dest.viewBias = this.viewBias;
        dest.intensity = this.intensity;
    }
}
VolumetricGI.BlockName = "VolumetricGIProbe";
VolumetricGI.volumetricCount = 0;
